import React from 'react';
import {
	ChonkyIconFA,
} from 'chonky-icon-fontawesome';
import CustomIcon from '../../Common/CustomIcon/CustomIcon';

// Extend Chonky's FontAwesome icon component to allow arbitrary FontAwesome icon names
// that are already registered globally through CustomIcon (library.add(fas)).
export const ChonkyIconExtended = (props) => {
	const {
		icon,
	} = props;
	if (icon === 'clone' || icon === 'sync-alt' || icon === 'visual_content_loop_icon_down_alligned') {
		return <CustomIcon icon={icon} />;
	}
	return <ChonkyIconFA {...props} />;
};

export default ChonkyIconExtended;
